import {
  Builder_,
  CardsSixty,
  On_Gradient_Card,
  Radio_,
  Stat_,
  ThemeContext,
  device,
  logo,
} from "monica-alexandria";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { prettifyPrice } from "../../../helpers/prettifyFunctions";
import { CartContext } from "../../../context/CartContext";
import { Subscribe } from '../../../styles/Layout.css'
import Coupon_ from '../../../components/billing/Coupon_'
import Annual_ from '../../../components/billing/Annual_'
import Lois_Plan from './Lois_Plan'

const LoisItems = styled.div`

  .Meta{

    &:hover{
      box-shadow: ${p => p.theme.out}; //TODO: remove this when we add another integration
    }
  }

  .Google{
    pointer-events: none;
    opacity: .5;
  }
`;

const LoisItemsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-gap: 2rem;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  h1,h6{
    white-space: nowrap;
  }

  @media ${device.lg} {
    grid-template-columns: 1fr;
  }

  @media ${device.md} {
    grid-template-columns: 1fr auto;
  }

  @media ${device.sm} {
    grid-template-columns: 1fr;
  }
`;

const LoisItemsPrice = styled.div`
  h5{white-space: nowrap}

  @media ${device.lg} {
    justify-self: flex-end;
  }

  @media ${device.md} {
    justify-self: flex-end;
  }

  @media ${device.sm} {
    justify-self: flex-end;
  }
`;

const LoisItemSources = styled.div``;

const LoisItemsTabs = styled.div``;

const LoisItemsTotal = styled.div`
  display: flex;
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 2px solid var(--greyDark);
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
`

export default function Lois_Items(props) {
  const { t } = useTranslation();
  const { theme } = useContext(ThemeContext);
  const { cart, setCart } = useContext(CartContext);
  const [toggles, setToggles] = useState([]);
  const [trial, setTrial] = useState(true)
  const [coupon, setCoupon] = useState('');
  const customer = window?.sessionStorage?.getItem('customer')

  const handleRadioChange = (event) => {
    props?.setSelectedOption(event.target.value);
  };

  const handleToggleClick = (index, source) => {
    const newToggles = [...toggles];
    newToggles[index] = !newToggles[index];
    setToggles(newToggles);

    if (newToggles[index]) {
      setCart(prevCart => [...prevCart, source]);
    } else {
      const updatedCart = cart.filter(item => item.priceId !== source.priceId);
      setCart(updatedCart);
    }
  };
  

  function prettifyCurrency(currency) {
    //TODO : change to currency
    if (currency == "eur") return "€";
    else return currency;
  }

  useEffect(() => {
    // Check if props.sources has exactly one item
    if (props?.sources && props?.sources?.length === 1) {
      // Set toggle state to true and prevent it from being untoggled
      setToggles([true]);
      if (!cart.some(item => item.priceId === props?.sources[0]?.priceId)) {
        setCart(prevCart => [...prevCart, props.sources[0]]);
      }
      // Add the single source to the cart if not already added
    } else {
      // For any other case, initialize toggles based on cart items
      const newToggles = props?.sources?.map(source => cart.some(item => item.priceId === source.priceId));
      setToggles(newToggles);
    }
  }, [cart, props.sources]);
    console.log('customer', customer)
    return (
    <LoisItems>
      <Builder_>
        {/* <LoisItemsRow>
        {props?.defaultItem ? <Stat_
          title={t("Subscription plan")}
          text={props?.defaultItem?.name}
          imgBehave="Contain"
          img={ cart[0]?.category ? logo[cart[0]?.category][theme] : "NotFound"}
        /> : null}
          <LoisItemsPrice>
            <h5>{`${prettifyCurrency(props?.defaultItem?.currency)}${prettifyPrice(props?.defaultItem?.amount, "month")}`}/{t("month")}</h5>
          </LoisItemsPrice>
        </LoisItemsRow> */}
        <Lois_Plan/>
        <Coupon_ discount={coupon} setDiscount={setCoupon} trial={trial} setTrial={setTrial} customer={customer}/>
      </Builder_>
      {props?.sources && props?.sources.length>0 ? (
        <LoisItemSources>
          <Builder_ title={t("Integrations")}>
            <CardsSixty>
            {props?.sources?.map((source, i) => (
              
              <On_Gradient_Card key={i} id={i} className="Meta"
                firstColor="var(--metaOne)" secondColor="var(--metaTwo)" title={source.name} img="https://genius1071.friktoriaservers.net/doitforme/morning/app/adsnap/sources/MetaLogo.png"
              >
                <h5>+ {`${prettifyCurrency(source?.currency)}${prettifyPrice(source?.amount)}`}/{t("month")}</h5>
                {/* <Toggle_Stat active={toggles[i]} onClick={() => handleToggleClick(i, source) }/> */}
              </On_Gradient_Card>
            ))}
              <On_Gradient_Card className="Google"
                firstColor="#ff3e30" secondColor="var(--white)" title="Google Ads" img="https://genius1071.friktoriaservers.net/doitforme/morning/app/adsnap/sources/GoogleLogo.png"
              >
                <h5>{t("Coming next")}</h5>
              </On_Gradient_Card>
          </CardsSixty>
            <LoisItemsTotal>
              <h3>{t("Total")}:</h3>
              <h3>{`${prettifyCurrency(props?.defaultItem?.currency)}${prettifyPrice(props?.sources?.map((source) => source?.amount+ props?.defaultItem?.amount))}`}/{t("month")}</h3>
            </LoisItemsTotal>
        </Builder_>
        </LoisItemSources>
      ) : null}
    </LoisItems>
  );
}
